import { Link } from "react-router-dom";
import WorkCard from "@/components/base/WorkCard";
import SectionHeading from "@/components/base/SectionHeading";
import { works } from "@/mocks/works";

export default function FeaturedWorks() {
  const featured = works.filter((w) => w.featured).slice(0, 4);
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <SectionHeading
          eyebrow="热门作品"
          title="人气韩国妖精漫画作品"
          desc="从宫廷谋略到都市怪谈，从治愈日常到强强对峙，为你盘点韩国妖精漫画里的代表作品与它们的漂亮女主。"
        />
        <Link
          to="/works"
          className="mb-8 inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-background-200 px-4 py-2 text-sm font-medium text-foreground-700 hover:border-accent-400 hover:text-accent-700 md:mb-10"
        >
          全部作品
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {featured.map((w) => (
          <div key={w.slug} className="reveal">
            <WorkCard work={w} />
          </div>
        ))}
      </div>
    </section>
  );
}